export  const RequestConstant = {
    REQUEST_VEHICLE_SAGA: "REQUEST_VEHICLE_SAGA",
    REQUEST_VEHICLE_REQUEST: "REQUEST_VEHICLE_REQUEST",
    REQUEST_VEHICLE_RESPONSE: "REQUEST_VEHICLE_RESPONSE",
    REQUEST_VEHICLE_API: "/get-requests",


    REQUEST_REJECT_API:'/reject-request',
    REQUEST_APPROVE_API:'/approve-request',
      REQUEST_UPDATE_API:'/update-vehicle-request'
  
    // ADD_CONNECTOR_SAGA: "ADD_CONNECTOR_SAGA",
    // ADD_CONNECTOR_REQUEST: "ADD_CONNECTOR_REQUEST",
    // ADD_CONNECTOR_RESPONSE: "ADD_CONNECTOR_RESPONSE",
    // ADD_CONNECTOR_API: "",
  };
  